module.exports = __webpack_public_path__ + "img/concept-ai-assisted-dev.bbbd1fd5.svg";